import script from "./PhoneNumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneNumberInput.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneNumberInput.vue?vue&type=style&index=0&id=52a70a8b&lang=css"

const __exports__ = script;

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon});
